import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import PublicationContent from "../ones/PublicationContent";

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..
    
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [ ])

  if(ready) {
    return (
      <>
        <section
          className="page-hero text-white"
          style={{
            backgroundImage:
              "linear-gradient(120deg, rgba(18,60,140,0.92), rgba(18,60,140,0.62))",
          }}
        >
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-lg-8" data-aos="fade-up">
                <p className="about-tag bg-light text-dark d-inline-flex align-items-center mb-3">
                  TEF Library
                </p>
                <h1 className="font-bold display-5 mb-3">Publications</h1>
                <p className="lead mb-0">
                  Explore TEF reports, research pieces, and editorial documents in one clean reading experience.
                </p>
              </div>
              <div className="col-lg-4 text-lg-end mt-4 mt-lg-0" data-aos="fade-left">
                <button
                  className="btn btn-light btn-rounded btn-padded shadow-sm"
                  onClick={() => appContext.navTo({ item: "resources" })}
                >
                  Explore Resources
                </button>
              </div>
            </div>
          </div>
        </section>
        <PublicationContent showHeader={false} />
        <Footer/>
      </>
    )
  } else {
    return (
      <div 
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }

  
}
